import { Fragment } from 'react'
import { Tab } from '@headlessui/react'

/* 
This components needs to be wrapped in a Tab.Group 
Receives an array of tabs titles.
*/

interface CustomHeadlessTabsProps {
  tabs: string[]
  className?: string
}

const CustomHeadlessTabs = ({
  tabs,
  className = ''
}: CustomHeadlessTabsProps) => (
  <Tab.List
    className={`bg-[#EEEEF0] w-full flex justify-between h-12 p-1 transition-all duration-200 text-xs gap-1 text-gray-900 font-bold rounded-lg mb-4 ${className}`}
  >
    {tabs.map((tab) => (
      <Tab key={tab} as={Fragment}>
        {({ selected }) => (
          <button
            type='button'
            className={`w-full h-10 min-h-full focus:outline-none focus-visible:outline-none focus:border-none focus:ring-0 transition-all duration-300 text-center ${
              !!selected && 'bg-white rounded-lg text-purple-900 shadow-tab'
            }`}
          >
            {tab}
          </button>
        )}
      </Tab>
    ))}
  </Tab.List>
)

export default CustomHeadlessTabs
